<template>
  <v-progress-circular indeterminate v-if="active" color="success"></v-progress-circular>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Loading',
    data() {
      return {
        active: false
      }
    },
    computed: {
      ...mapGetters(['loading'])
    },
    watch: {
      loading(value) {
        this.active = true
        Promise.all(value).then(() => {
          this.active = false
        });
      }
    }
    
  }
</script>
